import {
  Ellipsis,
  Input,
  NewButton,
  NewButtonVariant,
  Switch,
} from "@visiblethread/react-components";
import Flex, { GAP_CLASS } from "components/Flex";
import { bool, func, string } from "prop-types";
import { useEffect, useState } from "react";

import classes from "./WorkspaceToolbar.module.scss";

const WorkspaceToolbar = ({
  showWorkspace,
  onToggle,
  onSearch,
  entityName,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchApplied, setIsSearchApplied] = useState(false);

  useEffect(() => {
    if (!showWorkspace) {
      setSearchQuery("");
      setIsSearchApplied(false);
    }
  }, [showWorkspace]);

  const handleToggle = () => {
    onToggle(!showWorkspace);
  };

  const handleSearch = () => {
    if (!searchQuery) {
      return;
    }

    setIsSearchApplied(true);
    onSearch(searchQuery);
  };

  const handleClear = () => {
    setSearchQuery("");
    setIsSearchApplied(false);
    onSearch("");
  };

  const handleKeyUp = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <Flex
      gap={GAP_CLASS.GAP_400}
      justifyContent="space-between"
      className={classes.workspace_toolbar}
    >
      <div className={classes.workspace_toolbar__info_block}>
        <Flex
          gap={GAP_CLASS.GAP_150}
          className={classes.workspace_toolbar__show_docs}
        >
          <span className={classes["workspace_toolbar__label"]}>
            Show all docs across workspace
          </span>
          <Switch
            id="choose-shred-doc-workspace-toggle"
            state={showWorkspace}
            labeled
            onChange={handleToggle}
          />
        </Flex>
        <Flex
          gap={GAP_CLASS.GAP_050}
          className={classes.workspace_toolbar__label}
        >
          Viewing documents
          {showWorkspace ? (
            <strong> across the workspace</strong>
          ) : (
            <Ellipsis text={<strong> within {entityName || "this resource"}</strong>} />
          )}
        </Flex>
      </div>
      {showWorkspace && (
        <Flex
          className={classes.workspace_toolbar__search}
          gap={GAP_CLASS.GAP_200}
        >
          <Input
            value={searchQuery}
            onChange={setSearchQuery}
            onKeyUp={handleKeyUp}
            type="search"
            placeholder="Search here"
            className={classes["workspace_toolbar__search_input"]}
            aria-label="Search documents"
            showClearButton={isSearchApplied}
            onClear={handleClear}
          />
          <NewButton
            variant={NewButtonVariant.l1}
            disabled={!searchQuery}
            onClick={handleSearch}
          >
            Search
          </NewButton>
        </Flex>
      )}
    </Flex>
  );
};

WorkspaceToolbar.propTypes = {
  showWorkspace: bool.isRequired,
  onToggle: func.isRequired,
  onSearch: func.isRequired,
  entityName: string,
};

export default WorkspaceToolbar;
